import uuid from 'uuid/v4';
import cloneDeep from 'lodash/cloneDeep';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {
  getFormedTooltip
} from '../util/QuickReportsUtils';

export default (state = initialState.quickReports, action) => {
  switch (action.type) {
    case types.CLEAR_REPORTS_SAMPLE_WEIGHTED:
      {
        const keyType = `${action.targetGrid}Data`;
        const recycleElements = state.RecycleGridData ?
          [...state.RecycleGridData] :
          [];
        const selectedGridData = state[keyType] ? [...state[keyType]] : [];
        return {
          ...state,
          [keyType]: [],
          RecycleGridData: [...selectedGridData, ...recycleElements],
        };
      }
    case types.UPDATE_REPORTS_SAMPLE_WEIGHTED:
      {
        const keyType = `${action.targetGrid}Data`;
        return { ...state,
          [keyType]: [...action.gridData]
        };
      }
    case types.CLEAR_REPORT:
      {
        return { ...state,
          selectedReport: undefined,
          quickReportSelectedWeight: {},
        };
      }
    case types.CLEAR_SELECTED_WEIGHT_QUICK_REPORT: {
      return {
        ...state,
        quickReportSelectedWeight: {},
      };
    }
    case types.SELECT_REPORT:
      {
        return { ...state,
          selectedReport: { ...action.report },
        };
      }
    case types.CLEAR_ALL_REPORT:
      {
        return {
          ...initialState.quickReports,
        };
      }
    case types.GET_REPORTS_SAMPLE_WEIGHTED:
      {
        // Required Parameters: payload, targetGrid, expressionList, selectedNames
        // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
        const keyType = `${action.targetGrid}Data`;
        const gridData = action.gridData ? action.gridData : [];
        const titlePrefix = action.titlePrefix ? action.titlePrefix : '';

        const selectedQuickReportsKPIsTitle = { ...state.selectedQuickReportsKPIsTitle };

        const savedKPIs = { ...state.allSelectedQuickReportsKPIsInfo };
        const sampleWeightedKPIs = { ...state.sampleWeightedQuickReportsKPIs };

        action.expressionList.forEach((item, index) => {
          savedKPIs[item] = {
            modeled: action.payload[index] ? action.payload[index].modeled : false,
            productNo: action.productNo,
          };
          sampleWeightedKPIs[item] = {
            productNo: action.productNo,
            data: action.payload[index] ? [action.payload[index]] : [],
          };
        });

        const draggedItems = action.payload
          .filter(selectedEntry => selectedEntry)
          .map((selectedEntry, index) => {
            const title = `${titlePrefix}${action.selectedNames[index]}`;
            let originalTitle = title;
            selectedQuickReportsKPIsTitle[action.expressionList[index]] = title;
            if (action.originalNames && action.originalNames.length > 0) {
              originalTitle = action.originalNames[index];
            } else if (
              action.sourceGrid !== 'TargetDataGrid' &&
              action.sourceGrid !== 'BasesDataGrid'
            ) {
              originalTitle = '*USER_OR_SYSTEM_MODIFIED_LABEL*';
            }
            return {
              id: uuid(),
              sample: selectedEntry.intab ? selectedEntry.intab : 0,
              weighted: selectedEntry.weighted ?
                Number(selectedEntry.weighted.toFixed()) :
                0,
              keyword: action.expressionList[index],
              title,
              originalTitle,
              tooltip: action.objSmartSearchArray[0] ? 
              getFormedTooltip(action.objSmartSearchArray[0].objectsAdded): 
              state[keyType][0].tooltip,
            };
          });
        return { ...state,
          selectedQuickReportsKPIsTitle,
          [keyType]: [...gridData, ...draggedItems],
          allSelectedQuickReportsKPIsInfo: savedKPIs,
          sampleWeightedQuickReportsKPIs: sampleWeightedKPIs,
        };
      }
    case types.RUN_REPORT:
      {
        const selectedQuickReportsKPIsTitle = { ...state.selectedQuickReportsKPIsTitle };
        selectedQuickReportsKPIsTitle[action.payload.baseExpression] = action.payload.baseLabel;
        selectedQuickReportsKPIsTitle[action.payload.targetExpression] = action.payload.targetLabel;
        let payload = cloneDeep(action.payload);
        if (action.payload.reportName === 'MAP') {
          let updatedCensusData;
          let updatedNielsenData;
          let updatedStateData;
          let updatedMarketingRegionsData;
          let updatedStateGroupsData;
          let updatedMapDetailGroups = {};
          const censusData = payload.mapDetailGroups['Census Regions'];
          if (censusData) {
            const updatedCRIndexGroups = censusData.indexGroups.reverse();
            updatedCensusData = {
              ...censusData,
              indexGroups: updatedCRIndexGroups,
            }
            updatedMapDetailGroups = {
              ...updatedMapDetailGroups,
              'Census Regions': updatedCensusData,
            }
          }
          const nielsenData = payload.mapDetailGroups['Nielsen Regions']
          if (nielsenData) {
            const updatedNielsenIndexGroups = nielsenData.indexGroups.reverse();
            updatedNielsenData = {
              ...nielsenData,
              indexGroups: updatedNielsenIndexGroups,
            }
            updatedMapDetailGroups = {
              ...updatedMapDetailGroups,
              'Nielsen Regions': updatedNielsenData,
            }
          }

          const marketingRegionsData = payload.mapDetailGroups['Marketing Regions']
          if (marketingRegionsData) {
            const updatedMarketingRegionIndexGrps = marketingRegionsData.indexGroups.reverse();
            updatedMarketingRegionsData = {
              ...marketingRegionsData,
              indexGroups: updatedMarketingRegionIndexGrps,
            }
            updatedMapDetailGroups = {
              ...updatedMapDetailGroups,
              'Marketing Regions': updatedMarketingRegionsData,
            }
          }
          
          const stateGroupsData = payload.mapDetailGroups['State Groups']
          if (stateGroupsData) {
            const updatedStateGroupIndexGrps = stateGroupsData.indexGroups.reverse();
            updatedStateGroupsData = {
              ...stateGroupsData,
              indexGroups: updatedStateGroupIndexGrps,
            }
            updatedMapDetailGroups = {
              ...updatedMapDetailGroups,
              'State Groups': updatedStateGroupsData,
            }
          }
          
          const stateData = payload.mapDetailGroups.States
          if (stateData) {
            const updatedStateIndexGroups = stateData.indexGroups.reverse();
            updatedStateData = {
              ...stateData,
              indexGroups: updatedStateIndexGroups,
            }
            updatedMapDetailGroups = {
              ...updatedMapDetailGroups,
              States: updatedStateData,
            }
          }
          payload = {
            ...payload,
            mapDetailGroups: {
              ...updatedMapDetailGroups
            }
          }
        }
        return {
          ...state,
          selectedQuickReportsKPIsTitle,
          reportResult: { ...payload },
          quickReportSelectedWeight: action.selectedWeight,
        };
      }
    case types.ADD_QUICKREPORT_PARAMS_REDUX:
      {
        return {
          ...state,
          exportParams: {
            ...action.payload,
          },
        };
      }

    case types.CLEAR_SAMPLE_WEIGHTED_QUICKREPORTS_KPI: {
      return {
        ...state,
        sampleWeightedQuickReportsKPIs: {},
      };
    }
    case types.EXPORT_REPORT:
      {
        const link = document.createElement('a');
        document.body.appendChild(link);
        link.href = action.payload.url;
        link.click();
        return state;
      }
    case types.UPDATE_MAP_SETTINGS:
      return {
        ...state,
        mapSettings: {
          ...state.mapSettings,
          [action.key]: action.value,
        }
      }
    
      case types.SET_QUICK_REPORT_FLAG:
        return {
          ...state,
          quickReportRunFlag: action.payload,
        }

    
    default:
      return state;
  }
}